import state from "./state";
import actions from "./actions";
import mutations from "./mutations";
import consts from "./consts";

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    consts,
};